import React, { useEffect, useState, useMemo } from "react"
import API from "../../Common/API"
import InlineTextField from "../../Components/InLineTextField";
import DatatableLoader from "../../Components/Loaders/DataTableLoader"
import { datatableTheme } from "../../Common/dataTableTheme"
import DataTable, { createTheme } from "react-data-table-component"
import { motion } from 'framer-motion'
import { useHistory } from "react-router-dom";
import { FaEye, FaPlus } from "react-icons/fa6";
import { FaCheckCircle, FaImage, FaImages, FaPen, FaTrash } from "react-icons/fa";
import Dialog from '../../Components/Dialog'
import Button from "../../Components/Button";
import { useDispatch } from "react-redux";
import { setAlert } from "../../Store/Theme/actions";
import * as Yup from 'yup'
import { useFormik } from "formik";
import dummy from '../../Assets/Images/dummyProfile.jpeg'
import { MdImage, MdPayment, MdPublishedWithChanges } from "react-icons/md";
import FieldSelect from "../../Components/FieldSelect";
import { useTranslation } from "react-i18next";

createTheme('defaultLight', datatableTheme.default)
createTheme('defaultDark', datatableTheme.dark)
const status = [{ id: 0, value: 'Pending' }, { id: 1, value: 'Approved' }, { id: 2, value: 'Declined' }, { id: 3, value: 'In-active' }, { id: 4, value: 'Happy customer' }, { id: 5, value: 'Blocked' }, {id:6, value:'Under Review'}]

const initialActivePlans = {
    planId: '',
    userId: '',
    // planValidityDate: new Date(Date.now() + planDetails.planValidity * 24 * 60 * 60 * 1000),
    planValidityDate: '',
    downloadCount: 0,
}
const Users = () => {

    const [loading, setLoading] = useState(true)
    const [filter, setFilter] = useState('')
    const [userList, setUserList] = useState([])
    const history = useHistory()
    const [userId, setUserId] = useState()
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openActiveModal, setOpenActiveModal] = useState(false)
    const dispatch = useDispatch()
    const [openchangeStatus, setOpenChangeStatus] = useState(false)
    const [count, setCount] = useState(0)
    const [plans, setPlans] = useState([])
    const [planDetails, setPlanDetails] = useState([])
    const [currentPage, setCurrentPage] = useState(1); // Assuming page index starts at 1
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const {t} = useTranslation()
    const [totalUsers,setTotalUsers]=useState(0)
     const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPages, setTotalPages] = useState(0)
  const [genderFilter,setGenderFilter] = useState("")


  const fetchUsers = async () => {
    setLoading(true)
    try {
      const response = await API.get(`/user/getUserList`,{
  params: { page, limit, search: filter }})
      if (response.status === 200) {
        setUserList(response.data.data)
        // setTotalPages(response.data.data.totalPages) // Assuming your API returns this
        // setTotalUsers(response.data.data.totalUsers)
        setLoading(false)
      }
    } catch (error) {
      console.error("Error fetching users:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [count])



    useEffect(() => {
        setLoading(true)
        API.get('/plans/getPlansList').then((planRes) => {
            if (planRes.status === 200) {
                setPlans(planRes.data.data.map((c) => { return { text: c.planName, value: c._id } }))
                setPlanDetails(planRes.data.data)
            }
        })
    }, [count])
    const columns = useMemo(() => [
        {
            name: 'S.No', selector: (row, i) => (currentPage - 1) * rowsPerPage + i + 1,
            initialActive: true, sortable: true, width: '100px'
        },
        {
            name : <FaImage/>, selector:(row,i)=> <motion.div className="w-full h-full px-2 py-1 flex flex-row text-center justify-center items-center"><img src={row?.images.length > 0 ? row?.images[0]?.imageUrl : dummy} alt="user" className="w-50 h-32 object-contain" /></motion.div>,
            initialActive: true, sortable: true,
        },
        { name: 'Ref Id', selector: (row, i) => row.refId, initialActive: true, sortable: true, width: '100px' },
        { name: 'First Name', selector: row => row.firstName, sortable: true },
        { name: 'Surname', selector: row => row.surname, sortable: true },
        // { name: 'Native', selector: row => row.familyInformation.fatherNative, sortable: true },
        { name: 'Mobile', selector: row => row?.contactInformation?.mobileNumber, sortable: true },
        { name: "Verification", selector: row => status.filter((x) => x.id === row.status)[0].value, sortable: true },
        { name: "Status", selector: row => row.activeStat === 'A' ? "Active" : "Deactived", sortable: true },
        {
            name: "Action", selector: row => <motion.div className="flex flex-row w-full gap-3 justify-between">
                <FaEye title="View" className="cursor-pointer text-green-900 " onClick={() => viewUser(row)} />
                <FaPen title="Edit" className="cursor-pointer text-indigo-900 " onClick={() => editUser(row)} />
                <FaImages title="Manage Images" className="cursor-pointer text-indigo-900 " onClick={() => history.push(`/manageImages/${row._id}`)} />
                {row.status === 1 && !row.planActive && <MdPublishedWithChanges title="Change Status" className="cursor-pointer text-indigo-900 " onClick={() => openStatuses(row)} />}
                {row.activeStat === 'A' ? <FaTrash title="Delete" className="cursor-pointer text-[red] " onClick={() => deactivateUser(row)} /> :
                    <FaCheckCircle title="Delete" className="cursor-pointer text-[green] " onClick={() => activateUser(row)} />}
            </motion.div>, sortable: true
        },
    ], [currentPage, rowsPerPage])// eslint-disable-line

   const filteredcasedetails = useMemo(() => {
    const filterSplit = filter.toLowerCase().split(' ').filter(Boolean);

    const flattenObjectToString = (obj) => {
        let result = '';
        const stack = [obj];

        while (stack.length) {
            const current = stack.pop();
            for (const key in current) {
                const value = current[key];
                if (value && typeof value === 'object') {
                    stack.push(value);
                } else if (value != null) {
                    result += ' ' + value.toString().toLowerCase();
                }
            }
        }

        return result;
    };

    const firstNameMatches = [];
    const refIdMatches = [];
    const otherMatches = [];

    userList.forEach((user) => {
        const profile = user?.profileType?.toLowerCase?.() || ''; // "groom" or "bride"

        // Apply gender filter
        if (genderFilter && profile !== genderFilter.toLowerCase()) {
            return;
        }

        const firstName = user?.firstName?.toLowerCase() || '';
        const refId = user?.refId?.toLowerCase() || '';
        const dob = user?.dateOfBirth?.toLowerCase?.() || '';
        const searchString = flattenObjectToString(user);

        const matchesAll = filterSplit.every((kw) => searchString.includes(kw));

        if (matchesAll) {
            const firstNameMatchesAll = filterSplit.every((kw) => firstName.includes(kw));
            const refIdMatchesAll = filterSplit.every((kw) => refId.includes(kw));
            const dobMatchesAll = filterSplit.every((kw) => dob.includes(kw));

            if (firstNameMatchesAll) {
                firstNameMatches.push(user);
            } else if (refIdMatchesAll) {
                refIdMatches.push(user);
            } else {
                otherMatches.push(user);
            }
        }
    });

    return [...firstNameMatches, ...refIdMatches, ...otherMatches];
}, [userList, filter, genderFilter]);

    const SubHeader = useMemo(() => (
        <div className="flex flex-row items-center">
            <motion.div className="bg-primeColor rounded-full px-2 py-1 mx-2 flex flex-row items-center text-white cursor-pointer" onClick={()=>downloadAsExcel()}>Export As Excel</motion.div>
            <select
                className="px-3 py-1 mx-2 border border-gray-300 rounded-md text-sm focus:outline-none"
                value={genderFilter}
                onChange={(e) => setGenderFilter(e.target.value)}
            >
                <option value="">All</option>
                <option value="groom">Male</option>
                <option value="bride">Female</option>
            </select>

            <InlineTextField label={"Search"} value={filter} setValue={setFilter} />
            <motion.div className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center" onClick={() => history.push(`/createUser`)}><FaPlus /></motion.div>
        </div>
    ), [filter,genderFilter])// eslint-disable-line

    const editUser = (values) => {
        // setUserId(values)
        // setOpenEditModal(true)
        history.push(`/edit/${values._id}`)
    }

    const viewUser = (values) => {
        // setUserId(values)
        // setOpenEditModal(true)
        history.push(`/view/${values._id}`)
    }
    const deactivateUser = (values) => {
        console.log(values)
        setUserId(values._id)
        setOpenDeleteModal(true)
    }

    const activateUser = (values) => {
        setUserId(values._id)
        setOpenActiveModal(true)
    }

    const openStatuses = (row) => {
        setOpenChangeStatus(true)
        planForm.setValues({ ...planForm.values, userId: row._id })
    }

    const deleteUser = () => {
        try {
            API.post(`/user/deactivateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'User Deactivated Successfully', active: true, type: 'success' }))
                    setOpenDeleteModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

    const reactiveUser = () => {
        try {
            API.post(`/user/activateUser/${userId}`).then((deRes) => {
                if (deRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'User activated Successfully', active: true, type: 'success' }))
                    setOpenActiveModal(false)
                    setCount(count + 1)
                }
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        }
    }

    const planFormSchema = Yup.object().shape({
        planId: Yup.string().required("Choose plan Id")
    })

    const planForm = useFormik({
        initialValues: initialActivePlans,
        validateOnMount: true,
        validationSchema: planFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log(values)
        }
    })


    const activatePlan = () => {
        let apiValues = {
            planId: planForm.values.planId,
            userId: planForm.values.userId,
            planValidityDate: new Date(Date.now() + planDetails.filter((x) => x._id === planForm.values.planId)[0].planValidity * 24 * 60 * 60 * 1000).toISOString(),
            downloadCount: 0,
        }
        API.post('/plans/subscribe', apiValues).then((subRes) => {
            if (subRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: 'Plan Activated Successfully', active: true, type: 'success' }))
                setCount(count + 1)
                setOpenChangeStatus(false)
            }
        }).catch((err) => {
            dispatch(setAlert({ title: "Error", subtitle: 'Something went wrong', active: true, type: 'error' }))
        })
    }


    const downloadAsExcel = async ()=>{
        try{
            const response = await API.get(`/user/xlsxUsersDownload`, {
                responseType: 'blob', // Ensure response is treated as a Blob
            })

            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `UsersList.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        }catch(err){    
            console.log(err)
            dispatch(setAlert({title:'Error',subtitle:'Something went wrong while downloading',active:true,type:'error'}))
        }
    }

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                   {/* <DataTable
  title="User List"
  theme="defaultLight"
  columns={columns}
  data={filteredcasedetails}
  pagination
  paginationServer
  paginationTotalRows={totalUsers}
  paginationPerPage={rowsPerPage}
  paginationDefaultPage={page} // <<— control page number
  onChangePage={val => setPage(val)}
  highlightOnHover
  selectableRowsHighlight
  persistTableHead
  subHeader
  subHeaderComponent={SubHeader}
  noDataComponent="There are no records to display"
/> */}
<DataTable
                        title="User List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            {/* <Dialog injectClass={'min-w-screen'} showDialog={openEditModal} title={'Edit User'} onClose={() => setOpenEditModal(false)}>
                <PreviewUser registerValues={userId} onClose={() => setOpenEditModal(false)} />
            </Dialog> */}
            <Dialog injectClass="w-350px" showDialog={openchangeStatus} title={'Activate Plan'} onClose={() => setOpenChangeStatus(false)}>
                <motion.div className="w-full flex flex-col">
                    <FieldSelect label={'Choose Plan'} fieldProps={planForm.getFieldProps('planId')} fieldHelper={planForm.getFieldHelpers('planId')} fieldMeta={planForm.getFieldMeta('planId')} edit={true} dataLoaded={true} options={plans} />
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'text-black rounded-full cursor-pointer'} onClick={() => setOpenChangeStatus(false)}>Cancel</Button>
                        <Button injectClass={'bg-primeColor text-white rounded-full cursor-pointer'} onClick={() => activatePlan()}>Activate</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openActiveModal} title={'Activate User'} onClose={() => setOpenActiveModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to activate this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenActiveModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => reactiveUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog injectClass="w-350px" showDialog={openDeleteModal} title={'Deactivate User'} onClose={() => setOpenDeleteModal(false)}>
                <motion.div className="w-full flex flex-col">
                    Are you sure you want to delete this user.
                    <motion.div className="w-full flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/90 text-white rounded-full cursor-pointer'} onClick={() => setOpenDeleteModal(false)}>No</Button>
                        <Button injectClass={'bg-[green] text-white rounded-full cursor-pointer'} onClick={() => deleteUser()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default Users